// @module NXTurn.ShoppingExtensions.ViewInventory
define('C3.ShoppingExtensions.ViewInventory.View'
,	[
	'c3_shoppingextensions_viewinventory.tpl'
	
	,   'GlobalViews.Breadcrumb.View'
	,	'C3.ShoppingExtensions.ViewInventory.Collection'
	,   'AjaxRequestsKiller'
	,	'Backbone.CompositeView'
	,	'GlobalViews.Pagination.View'
	,	'GlobalViews.ShowingCurrent.View'
	//,   'SC.Configuration' 
	,	'Backbone.CollectionView'
	,   'Handlebars'
	,   'C3.ShoppingExtensions.ViewInventory.ResultsView'
	,   'UrlHelper'
	,	'Backbone'
	,   'Utils'
    ]
, function (
	c3_shoppingextensions_viewinventory_tpl
	
	,   GlobalViewsBreadcrumbView
	,   ViewInventoryCollection
	,   AjaxRequestsKiller
	,   BackboneCompositeView
	,   GlobalViewsPaginationView
	,   GlobalViewsShowingCurrentView
	//,   Configuration
	,   BackboneCollectionView
	,   Handlebars
	,   ViewInventoryResultsView
	,   UrlHelper
	,	Backbone
	,   Utils
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.ViewInventory.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_viewinventory_tpl

	//,   title : 'Inventory'	

	,	initialize: function (options) {
			console.log(options)
			this.groupName = options.group;
			this.title = this.groupName+' Inventory Page';
			this.application = options.application;

			this.options = options;

			this.contentNotLoaded = true;

			var self = this;
	        
	        this.listenCollection();

	        var url_options = Utils.parseUrlOptions(Backbone.history.fragment);

	        this.collection = options.collection;

	        /*this.collection.fetch({ data:{				
				pageNumber: options.pageNumber,
				resultsPerPage: 50,
				searchid : options.searchid,
				filters: ''
			} }).done(function(res) { 

				console.log(res)
			});*/

			this.application.getLayout().once('afterAppendView', self.getCollectionContent, self);	

	        this.page = url_options.page

			BackboneCompositeView.add(this);
		}

	,   events: {
		//'click [data-action="show-ie-popup"]': 'showIEPopup',
		'click [data-action="download-invt-results"]': 'downloadCSV'
	}

	,  getCollectionContent: function()
		{
			var self = this;

			this.collection.fetch({ data:{				
				pageNumber: self.options.pageNumber,
				resultsPerPage: 50,
				searchid : self.options.searchid,
				filters: ''
			} }).done(function(res) { 
				//console.log(res)
				self.contentNotLoaded = false;
				self._resultsView = self._buildResultsView();
				self._render();
			});

			
		}

	,   downloadCSV: function()
	{
		var grpname = this.groupName;

		var app = this.application;
		var Configuration = app.Configuration;

		var savedsearchConfiguration = Configuration.PDPInventorySavedSearches
		,   savedsearchConfigurationConfig = savedsearchConfiguration.config
			//console.log(savedsearchConfigurationConfig)

			var findProductGroup = _.findWhere(savedsearchConfigurationConfig, {
                    productgroup: grpname
                });

			console.log(findProductGroup)
		//$('.download-csv').text('Processing...')	
		//var url = "https://4953269.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1300&deploy=1&compid=4953269&h=7a0eb1a4a297a9db9288&searchinternalid="+findProductGroup.savedsearchid+"&downloadFileLabel="+findProductGroup.productgroup+" Inventory";
		var url = "https://4953269.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1300&deploy=1&compid=4953269&ns-at=AAEJ7tMQLKoI0DxUUlBnv_Re5QQLqJMGG0DVELVaN6-AFmU7jSQ&searchinternalid="+findProductGroup.savedsearchid+"&downloadFileLabel="+findProductGroup.productgroup+" Inventory";
		window.location.href = url;
	}

	,	listenCollection: function ()
		{
			this.setLoading(true);

			this.collection.on({
				request: jQuery.proxy(this, 'setLoading', true)
			,	reset: jQuery.proxy(this, 'setLoading', false)
			});
		}
		
	,	setLoading: function (value)
		{
			this.isLoading = value;
		}	

	,	bindings: {
		}

	, 	childViews: {
			'Global.Breadcrumb': function() {
				var ieBreadcrumbs = [];

				 ieBreadcrumbs[0] = {
		                href : '/',
		                'data-hashtag' : '#',
		                'data-touchpoint': "home",
		                hasDataHashtag: true,
		                hasDataTouchpoint: true,
		                text: "Home"
		          }

	           	ieBreadcrumbs[1] = {
                     href : '/',
                     text: this.groupName+" Inventory"
                }

	        	return new GlobalViewsBreadcrumbView({
	        			 pages: ieBreadcrumbs 
	        		});
        	}
        ,   'ViewInventory.Results': function() {
	         return this._resultsView;
	        }
	    ,	'GlobalViews.Pagination': function()
			{
				var app = this.application;
				var Pagination = new GlobalViewsPaginationView(_.extend({
					totalPages: Math.ceil(this.collection.totalRecordsFound / this.collection.recordsPerPage)
				}, app.Configuration.defaultPaginationSettings));

				return Pagination;
			}
		,	'GlobalViews.ShowCurrentPage': function()
			{
				return new GlobalViewsShowingCurrentView({
					items_per_page: this.collection.recordsPerPage
		 		,	total_items: this.collection.totalRecordsFound
				,	total_pages: Math.ceil(this.collection.totalRecordsFound / this.collection.recordsPerPage)
				});
			}
		}


	, _buildResultsView: function() {
	        var self = this;
	        var selectedColumns = [];
	        
	       // var stockCollection = this.collection;
	        var stockCollection = this.collection.models[0].get('searchResults');
	        	//console.log(stockCollection)

	        var records_collection = new Backbone.Collection(
	            stockCollection.map(function(item) {

	            	//console.log(item)

	            	var values = item.values;
	            	var newArray = []

	            	var additionalValues = item.additionalValues
	            	,   isonline = false
	            	,   url = ''
	            	
	            	if(additionalValues.Display_In_WebSite == true){
	            		isonline = true;
	            		url = additionalValues.Item_URL_Component;
	            	}

	            	//console.log(additionalValues)
	            	$.each(values, function(key, value) {
	            		//console.log(key)
	            		if(key == 'SKU')
	            		{
	            		   if(isonline == true)
	            		   	value = new Handlebars.SafeString(Utils.translate('<a href="'+url+'" class="sku-link" data-item-sku="$(0)">$(0)</a>', value));
	            		   //value = new Handlebars.SafeString(_('<a href="'+url+'" class="sku-link" data-item-sku="$(0)">$(0)</a>').translate(value))
	            		  // else	
	            		  // value = new Handlebars.SafeString(_('<a href="#" class="sku-link" data-item-sku="$(0)" data-action="show-ie-popup">$(0)</a>').translate(value))					 	
	            		}


	            		newArray.push({
					 		label : key,
					 		value : value/*,
					 		id : item.id*/
					 		})
					});

	            	//console.log(newArray)

	                var model = new Backbone.Model({
	                    id: item.id,
	                    recordType: item.recordType,
	                    columns : newArray
	                });
	                return model;
	            })
	        );
	        
	        this.showTracking = true ;
	        if(Backbone.history.fragment.indexOf('estimates') === 0) {
	        	this.showTracking = false
	        }

	        //console.log(records_collection)
	        
	        var returnItem =  new BackboneCollectionView({
	            childView: ViewInventoryResultsView,
	            collection: records_collection,
	            viewsPerRow: 1

	        });

	        //console.log(returnItem);
	        return returnItem;
	    }		
		//@method getContext @return NXTurn.ShoppingExtensions.ViewInventory.View.Context
	,	getContext: function getContext()
		{
			
			//console.log(this.groupName)
			return {
				groupName : this.groupName,
				contentNotLoaded : this.contentNotLoaded,
				responseSuccessStatus : this.collection.models[0] && this.collection.models[0].get('responseStatus') == "Success" ? true : false,
				pageResultsColumns : this.collection.models[0] && this.collection.models[0].get('searchColLabels'),				
				showPagination: !!(this.collection.totalRecordsFound && this.collection.recordsPerPage),
				collectionLengthGreaterThan0: this.collection.models[0] && this.collection.models[0].get('searchResults').length > 0
			};
		}
	});
});
